import { render, staticRenderFns } from "./customerMenu.vue?vue&type=template&id=dc7b181e&scoped=true&"
import script from "./customerMenu.vue?vue&type=script&lang=js&"
export * from "./customerMenu.vue?vue&type=script&lang=js&"
import style0 from "./customerMenu.vue?vue&type=style&index=0&id=dc7b181e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7b181e",
  null
  
)

export default component.exports